// NOM-035 — Guía de Referencia III: Factores de Riesgo Psicosocial + Entorno Organizacional (51+ trabajadores)
// 72 ítems, 5 categorías, 10 dominios

export const GUIA_III_PREGUNTAS = [
  {
    dominio: "Condiciones en el ambiente de trabajo",
    categoria: "Ambiente de trabajo",
    intro: "Para responder las preguntas siguientes considere las condiciones ambientales de su centro de trabajo.",
    preguntas: [
      { id: "g3_1", num: 1, texto: "El espacio donde trabajo me permite realizar mis actividades de manera segura e higiénica" },
      { id: "g3_2", num: 2, texto: "Mi trabajo me exige hacer mucho esfuerzo físico" },
      { id: "g3_3", num: 3, texto: "Me preocupa sufrir un accidente en mi trabajo" },
      { id: "g3_4", num: 4, texto: "Considero que en mi trabajo se aplican las normas de seguridad y salud en el trabajo" },
      { id: "g3_5", num: 5, texto: "Considero que las actividades que realizo son peligrosas" },
    ]
  },
  { dominio: "Carga de trabajo", categoria: "Factores propios de la actividad",
    intro: "Para responder a las preguntas siguientes piense en la cantidad y ritmo de trabajo que tiene.",
    preguntas: [
      { id: "g3_6", num: 6, texto: "Por la cantidad de trabajo que tengo debo quedarme tiempo adicional a mi turno" },
      { id: "g3_7", num: 7, texto: "Por la cantidad de trabajo que tengo debo trabajar sin parar" },
      { id: "g3_8", num: 8, texto: "Considero que es necesario mantener un ritmo de trabajo acelerado" },
    ]
  },
  { dominio: "Carga de trabajo", categoria: "Factores propios de la actividad",
    intro: "Las preguntas siguientes están relacionadas con el esfuerzo mental que le exige su trabajo.",
    preguntas: [
      { id: "g3_9", num: 9, texto: "Mi trabajo exige que esté muy concentrado" },
      { id: "g3_10", num: 10, texto: "Mi trabajo requiere que memorice mucha información" },
      { id: "g3_11", num: 11, texto: "En mi trabajo tengo que tomar decisiones difíciles muy rápido" },
      { id: "g3_12", num: 12, texto: "Mi trabajo exige que atienda varios asuntos al mismo tiempo" },
    ]
  },
  { dominio: "Carga de trabajo", categoria: "Factores propios de la actividad",
    intro: "Las preguntas siguientes están relacionadas con las actividades que realiza en su trabajo y las responsabilidades que tiene.",
    preguntas: [
      { id: "g3_13", num: 13, texto: "En mi trabajo soy responsable de cosas de mucho valor" },
      { id: "g3_14", num: 14, texto: "Respondo ante mi jefe por los resultados de toda mi área de trabajo" },
      { id: "g3_15", num: 15, texto: "En el trabajo me dan órdenes contradictorias" },
      { id: "g3_16", num: 16, texto: "Considero que en mi trabajo me piden hacer cosas innecesarias" },
    ]
  },
  { dominio: "Jornada de trabajo", categoria: "Organización del tiempo de trabajo",
    intro: "Las preguntas siguientes están relacionadas con su jornada de trabajo.",
    preguntas: [
      { id: "g3_17", num: 17, texto: "Trabajo horas extras más de tres veces a la semana" },
      { id: "g3_18", num: 18, texto: "Mi trabajo me exige laborar en días de descanso, festivos o fines de semana" },
    ]
  },
  { dominio: "Interferencia en la relación trabajo-familia", categoria: "Organización del tiempo de trabajo",
    visualContinue: true,
    preguntas: [
      { id: "g3_19", num: 19, texto: "Considero que el tiempo en el trabajo es mucho y perjudica mis actividades familiares o personales" },
      { id: "g3_20", num: 20, texto: "Debo atender asuntos de trabajo cuando estoy en casa" },
      { id: "g3_21", num: 21, texto: "Pienso en las actividades familiares o personales cuando estoy en mi trabajo" },
      { id: "g3_22", num: 22, texto: "Pienso que mis responsabilidades familiares afectan mi trabajo" },
    ]
  },
  { dominio: "Falta de control sobre el trabajo", categoria: "Factores propios de la actividad",
    intro: "Las preguntas siguientes están relacionadas con las decisiones que puede tomar en su trabajo.",
    preguntas: [
      { id: "g3_23", num: 23, texto: "Mi trabajo permite que desarrolle nuevas habilidades" },
      { id: "g3_24", num: 24, texto: "En mi trabajo puedo aspirar a un mejor puesto" },
      { id: "g3_25", num: 25, texto: "Durante mi jornada de trabajo puedo tomar pausas cuando las necesito" },
      { id: "g3_26", num: 26, texto: "Puedo decidir cuánto trabajo realizo durante la jornada laboral" },
      { id: "g3_27", num: 27, texto: "Puedo decidir la velocidad a la que realizo mis actividades en mi trabajo" },
      { id: "g3_28", num: 28, texto: "Puedo cambiar el orden de las actividades que realizo en mi trabajo" },
    ]
  },
  { dominio: "Falta de control sobre el trabajo", categoria: "Factores propios de la actividad",
    intro: "Las preguntas siguientes están relacionadas con cualquier tipo de cambio que ocurra en su trabajo (considere los últimos cambios realizados).",
    preguntas: [
      { id: "g3_29", num: 29, texto: "Los cambios que se presentan en mi trabajo dificultan mi labor" },
      { id: "g3_30", num: 30, texto: "Cuando se presentan cambios en mi trabajo se tienen en cuenta mis ideas o aportaciones" },
    ]
  },
  { dominio: "Liderazgo", categoria: "Liderazgo y relaciones en el trabajo",
    intro: "Las preguntas siguientes están relacionadas con la capacitación e información que se le proporciona sobre su trabajo.",
    preguntas: [
      { id: "g3_31", num: 31, texto: "Me informan con claridad cuáles son mis funciones" },
      { id: "g3_32", num: 32, texto: "Me explican claramente los resultados que debo obtener en mi trabajo" },
      { id: "g3_33", num: 33, texto: "Me explican claramente los objetivos de mi trabajo" },
      { id: "g3_34", num: 34, texto: "Me informan con quién puedo resolver problemas o asuntos de trabajo" },
    ]
  },
  { dominio: "Falta de control sobre el trabajo", categoria: "Factores propios de la actividad",
    visualContinue: true,
    preguntas: [
      { id: "g3_35", num: 35, texto: "Me permiten asistir a capacitaciones relacionadas con mi trabajo" },
      { id: "g3_36", num: 36, texto: "Recibo capacitación útil para hacer mi trabajo" },
    ]
  },
  { dominio: "Liderazgo", categoria: "Liderazgo y relaciones en el trabajo",
    intro: "Las preguntas siguientes están relacionadas con el o los jefes con quien tiene contacto.",
    preguntas: [
      { id: "g3_37", num: 37, texto: "Mi jefe ayuda a organizar mejor el trabajo" },
      { id: "g3_38", num: 38, texto: "Mi jefe tiene en cuenta mis puntos de vista y opiniones" },
      { id: "g3_39", num: 39, texto: "Mi jefe me comunica a tiempo la información relacionada con el trabajo" },
      { id: "g3_40", num: 40, texto: "La orientación que me da mi jefe me ayuda a realizar mejor mi trabajo" },
      { id: "g3_41", num: 41, texto: "Mi jefe ayuda a solucionar los problemas que se presentan en el trabajo" },
    ]
  },
  { dominio: "Relaciones en el trabajo", categoria: "Liderazgo y relaciones en el trabajo",
    intro: "Las preguntas siguientes se refieren a las relaciones con sus compañeros.",
    preguntas: [
      { id: "g3_42", num: 42, texto: "Puedo confiar en mis compañeros de trabajo" },
      { id: "g3_43", num: 43, texto: "Entre compañeros solucionamos los problemas de trabajo de forma respetuosa" },
      { id: "g3_44", num: 44, texto: "En mi trabajo me hacen sentir parte del grupo" },
      { id: "g3_45", num: 45, texto: "Cuando tenemos que realizar trabajo de equipo los compañeros colaboran" },
      { id: "g3_46", num: 46, texto: "Mis compañeros de trabajo me ayudan cuando tengo dificultades" },
    ]
  },
  { dominio: "Reconocimiento del desempeño", categoria: "Entorno organizacional",
    intro: "Las preguntas siguientes están relacionadas con la información que recibe sobre su rendimiento en el trabajo, el reconocimiento, el sentido de pertenencia y la estabilidad que le ofrece su trabajo.",
    preguntas: [
      { id: "g3_47", num: 47, texto: "Me informan sobre lo que hago bien en mi trabajo" },
      { id: "g3_48", num: 48, texto: "La forma como evalúan mi trabajo en mi centro de trabajo me ayuda a mejorar mi desempeño" },
      { id: "g3_49", num: 49, texto: "En mi centro de trabajo me pagan a tiempo mi salario" },
      { id: "g3_50", num: 50, texto: "El pago que recibo es el que merezco por el trabajo que realizo" },
      { id: "g3_51", num: 51, texto: "Si obtengo los resultados esperados en mi trabajo me recompensan o reconocen" },
      { id: "g3_52", num: 52, texto: "Las personas que hacen bien el trabajo pueden crecer laboralmente" },
    ]
  },
  { dominio: "Insuficiente sentido de pertenencia e, inestabilidad", categoria: "Entorno organizacional",
    visualContinue: true,
    preguntas: [
      { id: "g3_53", num: 53, texto: "Considero que mi trabajo es estable" },
      { id: "g3_54", num: 54, texto: "En mi trabajo existe continua rotación de personal" },
      { id: "g3_55", num: 55, texto: "Siento orgullo de laborar en este centro de trabajo" },
      { id: "g3_56", num: 56, texto: "Me siento comprometido con mi trabajo" },
    ]
  },
  { dominio: "Violencia", categoria: "Liderazgo y relaciones en el trabajo",
    intro: "Las preguntas siguientes están relacionadas con actos de violencia laboral (malos tratos, acoso, hostigamiento, acoso psicológico).",
    preguntas: [
      { id: "g3_57", num: 57, texto: "En mi trabajo puedo expresarme libremente sin interrupciones" },
      { id: "g3_58", num: 58, texto: "Recibo críticas constantes a mi persona y/o trabajo" },
      { id: "g3_59", num: 59, texto: "Recibo burlas, calumnias, difamaciones, humillaciones o ridiculizaciones" },
      { id: "g3_60", num: 60, texto: "Se ignora mi presencia o se me excluye de las reuniones de trabajo y en la toma de decisiones" },
      { id: "g3_61", num: 61, texto: "Se manipulan las situaciones de trabajo para hacerme parecer un mal trabajador" },
      { id: "g3_62", num: 62, texto: "Se ignoran mis éxitos laborales y se atribuyen a otros trabajadores" },
      { id: "g3_63", num: 63, texto: "Me bloquean o impiden las oportunidades que tengo para obtener ascenso o mejora en mi trabajo" },
      { id: "g3_64", num: 64, texto: "He presenciado actos de violencia en mi centro de trabajo" },
    ]
  },
  { dominio: "Carga de trabajo", categoria: "Factores propios de la actividad",
    intro: "Las preguntas siguientes están relacionadas con la atención a clientes y usuarios.",
    preguntaFiltro: { id: "g3_filtro_clientes", texto: "En mi trabajo debo brindar servicio a clientes o usuarios" },
    preguntas: [
      { id: "g3_65", num: 65, texto: "Atiendo clientes o usuarios muy enojados", condicional: true },
      { id: "g3_66", num: 66, texto: "Mi trabajo me exige atender personas muy necesitadas de ayuda o enfermas", condicional: true },
      { id: "g3_67", num: 67, texto: "Para hacer mi trabajo debo demostrar sentimientos distintos a los míos", condicional: true },
      { id: "g3_68", num: 68, texto: "Mi trabajo me exige atender situaciones de violencia", condicional: true },
    ]
  },
  { dominio: "Relaciones en el trabajo", categoria: "Liderazgo y relaciones en el trabajo",
    intro: "Las preguntas siguientes están relacionadas con las actitudes de las personas que supervisa.",
    preguntaFiltro: { id: "g3_filtro_jefe", texto: "Soy jefe de otros trabajadores" },
    preguntas: [
      { id: "g3_69", num: 69, texto: "Comunican tarde los asuntos de trabajo", condicional: true },
      { id: "g3_70", num: 70, texto: "Dificultan el logro de los resultados del trabajo", condicional: true },
      { id: "g3_71", num: 71, texto: "Cooperan poco cuando se necesita", condicional: true },
      { id: "g3_72", num: 72, texto: "Ignoran las sugerencias para mejorar su trabajo", condicional: true },
    ]
  },
];

export const OPCIONES_GUIA_III = [
  { valor: 0, texto: "Siempre" },
  { valor: 1, texto: "Casi siempre" },
  { valor: 2, texto: "Algunas veces" },
  { valor: 3, texto: "Casi nunca" },
  { valor: 4, texto: "Nunca" },
];

// Ítems invertidos Guía III (Tabla 5): ítems positivos donde Siempre=0, Nunca=4
export const ITEMS_INVERTIDOS_GIII = [
  "g3_1","g3_4","g3_23","g3_24","g3_25","g3_26","g3_27","g3_28","g3_30",
  "g3_31","g3_32","g3_33","g3_34","g3_35","g3_36",
  "g3_37","g3_38","g3_39","g3_40","g3_41",
  "g3_42","g3_43","g3_44","g3_45","g3_46",
  "g3_47","g3_48","g3_49","g3_50","g3_51","g3_52","g3_53","g3_55","g3_56","g3_57"
];
